
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-resources",
      function () {
        return require("private-next-pages/free-resources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-resources"])
      });
    }
  